const spacing = (multiplier: number) => `${multiplier * 8}px`;

export const HEIGHT_OF_DESKTOP_HEAD = '57px';
export const HEIGHT_OF_MOBILE_HEAD = '47px';
export const HEIGHT_OF_MOBILE_PAGE_TITLE = '43px';
export const HEIGHT_OF_MOBILE_SUBPAGES = '35px';

export const HEIGHT_OF_DESKTOP_HEAD_CONTAINER = `calc(${spacing(3)} + ${HEIGHT_OF_DESKTOP_HEAD} + ${spacing(3)})`;
export const HEIGHT_OF_MOBILE_HEAD_CONTAINER = `calc(${spacing(
  1
)} + ${HEIGHT_OF_MOBILE_HEAD} + ${HEIGHT_OF_MOBILE_PAGE_TITLE})`;
